import { isAxiosError } from 'axios';
import {
    type WebsiteError,
    WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost,
} from '@clients/TrackingApi';

const ERROR_BATCH_MILLIS = 1000;
const ERROR_MAX_COUNT = 100;

let errorQueue: WebsiteError[] = [];
let timeout: number | NodeJS.Timeout | undefined;
function start() {
    if (timeout) {
        return;
    }
    timeout = setTimeout(() => {
        if (!errorQueue.length) {
            return;
        }
        const clone = [...errorQueue.slice(0, ERROR_MAX_COUNT)];
        WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost(
            {
                collectWebsiteErrorsInputDto: {
                    errors: clone,
                },
            }
        ).catch(/* if gold rusts, what iron shall do? */);
        errorQueue = [];
        timeout = undefined;
    }, ERROR_BATCH_MILLIS);
}

function reportError(e: Error) {
    errorQueue.push({
        message: e.message,
        stackTrace: e.stack,
    });
    start();
}

export function reportException(error: unknown) {
    if (error instanceof MrError && error.ignorable) {
        return;
    }
    if (isAxiosError(error)) {
        reportError({
            ...error,
            message: JSON.stringify(error.toJSON()),
            stack: error.stack,
        });
    } else if (error instanceof Error) {
        reportError(error);
    }
}

export class MrError extends Error {
    constructor(
        message?: string,
        public ignorable = false
    ) {
        super(message);
    }
}
